import JobWorkerInterviewWorkerDeclinedReason from "@/models/JobWorkerInterviews/JobWorkerInterviewWorkerDeclinedReason";
import JobWorkerNotInterestedReason from "@/models/JobWorkers/JobWorkerNotInterestedReason";

export default class AnonJobWorkerInterviewWorkerConfirmationReply 
{ 
	confirmed = false;
	declinedReason: JobWorkerInterviewWorkerDeclinedReason = JobWorkerInterviewWorkerDeclinedReason.Undefined;
}